import _ from 'lodash';
import React, {PropTypes} from 'react';
import t from 'tcomb-form';
import is from 'is';
import {gettext} from '../i18n';


export function makeOptions(options, pkProp='id') {
    if (is.array(options)) {
        return options.map(item => {
            return { value: item[pkProp], text: item };
        });
    }

    return Object.keys(options).map(key => {
        return { value: key, text: options[key] };
    });
}


function baseFormFactory(Model, showErrors, manualErrors) {
    class BaseForm extends React.Component {
        static propTypes = {
            initialFormData: PropTypes.object,
            errors: PropTypes.object,
        }

        constructor(props) {
            super(props);

            this.autoFieldLabels = 'labels';
            this.nonFieldErrorsField = null;
            this.state = {
                isValid: true,
                value: props.initialFormData || {},
                errors: null
            };
        }

        getValue() {
            return this.refs.form.getValue();
        }

        resetForm() {
            this.setState({value: {}});
        }

        getModel() {
            return Model;
        }

        getOptions() {
            let options = {
                auto: this.autoFieldLabels,
                template: this.formLayout.bind(this),
            };
            _.assign(options, {fields: this.getFieldOptions()});

            return this.putServerErrors(options, this.props.errors, this.nonFieldErrorsField, this.state.errors);
        }
        getFieldOptions() {
            return {};
        }

        formLayout(locals, wrapperClassName='inputs') {
            const renderedInputs = Object.keys(locals.inputs).map(key => {
                return locals.inputs[key];
            });
            return (
                <div className={wrapperClassName}>
                    {renderedInputs}
                </div>
            );
        }

        putServerErrors(options, errors, nonField, fallBackErrors={}) {
            Object.keys(options.fields || {}).forEach(fKey => {
                const field = options.fields[fKey] || {};
                let fError = errors && errors.getFieldError && errors.getFieldError(fKey, fKey === nonField) || null;
                if (fError === null) {
                    fError = fallBackErrors && fallBackErrors[fKey] || null;
                }
                field.hasError = !!fError;
                field.error = fError;

                options.fields[fKey] = field;
            });

            return options;
        }

        buildOptions() {
            const options = this.getOptions();

            if (!showErrors || manualErrors) {
                return options;
            }

            if (this.state.errors) {
                if (!options.fields) {
                    options.fields = {};
                }

                for (let key in this.state.errors) {
                    if (this.state.errors.hasOwnProperty(key)) {
                        const fieldKey = key.split('||')[0];

                        if (!options.fields[fieldKey]) {
                            options.fields[fieldKey] = {};
                        }

                        options.fields[fieldKey].hasError = true;
                        options.fields[fieldKey].error = this.state.errors[key];
                    }
                }
            }

            return options;
        }

        postValidate(state, value) {
            return state;
        }

        validate(onlyReturn, value) {
            if (this.refs.form) {
                const res = this.refs.form.validate();
                let state = {
                    errors: showErrors ? BaseForm.makeErrors(res.errors) : null,
                    isValid: res.isValid()
                };

                state = this.postValidate(state, value);

                if (onlyReturn) {
                    return state;
                }

                this.setState(state);
            }

            return null;
        }

        onChange(value) {
            const res = this.validate(true, value);
            this.setState(_.extend(res || {}, {
                value: value,
                errors: res.errors,
                isValid: res.isValid
            }));
        }


        render() {
            // Non-field errors are shown above the fields, unless this.nonFieldErrorsField is specified.
            let generalErrors = null;
            if (this.props.errors && this.props.errors.nonFieldErrors && !this.nonFieldErrorsField) {
                generalErrors = (<div className="has-error form-general-error">
                    <span className="help-block error-block">{this.props.errors.nonFieldErrors}</span>
                </div>);
            }

            return (<div>
                {generalErrors}
                <t.form.Form autocomplete="false" ref="form" value={this.state.value} type={this.getModel()}
                             options={this.buildOptions()} onChange={this.onChange.bind(this)} noValidate/>
            </div>);
        }

        static makeErrors(errStruct) {
            if (errStruct) {
                const errors = {};

                errStruct.forEach(error => {
                    // Replace indecipherable tcomb errors for required but missing values.
                    const msg = error.actual === null ? gettext("This field is required") : error.message;
                    errors[error.path.join('||')] = msg;
                });

                return errors;
            }

            return null;
        }
    }

    return BaseForm;
}

export default baseFormFactory;



/** WEBPACK FOOTER **
 ** ./app/src/forms/BaseForm.js
 **/